import { Dialog, DialogContent } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { v4 } from "uuid";
import { Button } from "components/button";
import { ErrorComponent } from "components/common";
import { withErrorBoundary } from "react-error-boundary";
import { useNavigate } from "react-router-dom";

const PopupInfomation = ({
	title = "Title",
	dataTitle,
	data,
	handleClose = () => {},
}) => {
	const open = useSelector(state => state.employer.showPopup);
	const navigate = useNavigate()
	const handleViewDetail = () => {
		handleClose()
		setTimeout(() => navigate(`Edit?id=${data.id}`), 300);
	}
	return (
		<>
			{open && (
				<Dialog
					open={open}
					onClose={handleClose}
					className='pms-popup-form'
					aria-labelledby='alert-dialog-title'
					aria-describedby='alert-dialog-description'>
					<DialogContent>
						<div className='pms-form-edit'>
							<div className='form-title h-50px text-xl justify-between font-bold pl-40px flex items-center text-white bg-[#273E56]'>
								<div className='uppercase'>{title}</div>
								<button
									className='mfp-close close-popup font-light text-4xl w-50px h-50px flex items-center justify-center bg-primary font-light outline-none !text-white !opacity-100'
									onClick={handleClose}>
									<em className='fa-light fa-xmark pointer-events-none' />
								</button>
							</div>
							<div className='table-responsive table-style-1 p-40px'>
								<table>
									<tbody>
										{data &&
											Object.keys(dataTitle).map(
												(item, index) => {
													return (
														<tr key={v4()}>
															<td>
																{
																	dataTitle[
																		item
																	]
																}
															</td>
															<td>
																{data[item]}
															</td>
														</tr>
													);
												}
											)}
									</tbody>
								</table>
								<Button
									kind='add'
									className='mt-30px !ml-0 !justify-start mr-auto'
									onClick={handleViewDetail}>
									<i className='fa-light fa-file-user'></i>
									<span>Xem chi tiết</span>
								</Button>
							</div>
						</div>
					</DialogContent>
				</Dialog>
			)}
		</>
	);
};
PopupInfomation.propTypes = {
	dataTitle: PropTypes.object,
	data: PropTypes.object,
	handleClose: PropTypes.func,
};
export default withErrorBoundary(PopupInfomation, {
	FallbackComponent: ErrorComponent,
});
